var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1104_2151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3613 8.9188C21.1457 8.95586 21.0591 9.24802 21.2337 9.37981C21.3364 9.4573 21.3567 9.60339 21.2791 9.70598L17.2322 15.0561C16.4033 16.1518 14.7419 16.1048 13.9764 14.964L12.4522 12.6928C11.6638 11.518 9.93825 11.5108 9.14013 12.679L7.79062 14.6543C7.14826 15.5946 5.82633 15.7572 4.97524 15.0007L4.09853 14.2214C3.81099 13.9658 3.78253 13.5264 4.03471 13.2359C4.29076 12.9409 4.73832 12.9114 5.03083 13.1703L5.34794 13.451C5.85328 13.8984 6.63632 13.8015 7.01741 13.2445L9.14 10.1422C9.93851 8.97519 11.6629 8.9828 12.4511 10.1569L14.0358 12.5173C14.8016 13.658 16.4631 13.7046 17.2917 12.6086L18.8226 10.5835C19.351 9.88453 18.8903 8.81802 18.1177 8.40474C17.5224 8.08633 16.9983 7.64975 16.5777 7.12174C16.157 6.59373 15.8486 5.98539 15.6712 5.33401C15.3913 4.3059 14.5936 3.3335 13.5281 3.3335H3.16634C2.81272 3.3335 2.47358 3.47397 2.22353 3.72402C1.97348 3.97407 1.83301 4.31321 1.83301 4.66683V19.3335C1.83301 19.6871 1.97348 20.0263 2.22353 20.2763C2.47358 20.5264 2.81272 20.6668 3.16634 20.6668H21.833C22.1866 20.6668 22.5258 20.5264 22.7758 20.2763C23.0259 20.0263 23.1663 19.6871 23.1663 19.3335V9.24663C23.1663 8.80359 22.669 8.52345 22.2538 8.67812C21.9647 8.78582 21.6659 8.86645 21.3613 8.9188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5003 7.33317C22.3413 7.33317 23.8337 5.84079 23.8337 3.99984C23.8337 2.15889 22.3413 0.666504 20.5003 0.666504C18.6594 0.666504 17.167 2.15889 17.167 3.99984C17.167 5.84079 18.6594 7.33317 20.5003 7.33317Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1104_2151"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketsActive);
export default __webpack_public_path__ + "static/media/markets-active.69e95cbb14b2210e92f99a38c63a074a.svg";
export { ForwardRef as ReactComponent };